import {NgModule} from '@angular/core';
import {WorkPageComponent} from './work-page.component';
import {PageCommonModule} from '../shared/page-common.module';
import {FormsModule} from '../../components/forms/forms.module';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {StepScreenModule} from '../shared/step/step-screen.module';
import {WorkHistoryScreenComponent} from './steps/history/work-history-screen.component';
import {MilitaryExperienceScreenComponent} from './steps/military/military-experience-screen.component';
import {WorkObservationsScreenComponent} from './steps/observations/work-observations-screen.component';
import {ActivityLogsScreenComponent} from './steps/activity-logs/activity-logs-screen.component';
import {FileListModule} from '../../components/files/file-list/file-list.module';
import {FileUploaderModule} from '../../components/files/file-uploader/file-uploader.module';
import {WorkHistoryNotesScreenComponent} from './steps/work-history-notes/work-history-notes-screen.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        StepScreenModule,
        NgbDatepickerModule,
        FileListModule,
        FileUploaderModule
    ],
    declarations: [
        WorkPageComponent,
        WorkHistoryScreenComponent,
        MilitaryExperienceScreenComponent,
        WorkObservationsScreenComponent,
        ActivityLogsScreenComponent,
        WorkHistoryNotesScreenComponent
    ]
})
export class WorkPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/work/work-page.module.ts